module.exports = __webpack_public_path__ + "static/media/varietyglasswebm.ead9a1a2.webm";